import styled from "styled-components";
import { Paragraph2, WrapperContainer } from "../../../../../components";
import { colors } from "../../../../../consts";

export const GenerateSection = styled(WrapperContainer)`
  ${Paragraph2} {
    color: ${colors.RAISIN_80};

    &:first-of-type {
      color: ${colors.RAISIN_100};
      font-weight: 600;
    }
  }

  button {
    height: 40px;
    padding: 0 24px;

    min-width: 120px;
  }
`;

export const ScrollContentWrapper = styled(WrapperContainer)`
  overflow-y: auto;
  padding-bottom: 24px;

  > ${Paragraph2} {
    font-weight: 600;
  }
`;
